// ** MUI Imports
import MuiAppBar from '@mui/material/AppBar'
import { styled, useTheme } from '@mui/material/styles'
import MuiToolbar from '@mui/material/Toolbar'
import useScrollTrigger from '@mui/material/useScrollTrigger'
import useMediaQuery from '@mui/material/useMediaQuery'

// ** Util Import

const AppBar = styled(MuiAppBar)(({ theme }) => ({
  alignItems: 'center',
  justifyContent: 'center',
  padding: theme.spacing(0, 6),
  backgroundColor: 'transparent',
  color: theme.palette.text.primary,
  minHeight: '60px',
  transition: 'transform 225ms cubic-bezier(0, 0, 0.2, 1)',
  [theme.breakpoints.down('sm')]: {
    paddingLeft: theme.spacing(4),
    paddingRight: theme.spacing(4)
  }
}))

const Toolbar = styled(MuiToolbar)(({ theme }) => ({
  width: '100%',
  padding: '0 !important',
  borderBottomLeftRadius: theme.shape.borderRadius,
  borderBottomRightRadius: theme.shape.borderRadius,
  minHeight: `60px !important`,
  transition: 'padding .25s ease-in-out, box-shadow .25s ease-in-out, backdrop-filter .25s ease-in-out'
}))

// 与 ExpirationReminder banner 共用，保证下滑隐藏时同步上移
export const HEADER_HIDE_SCROLL_OPTIONS = { threshold: 80, disableHysteresis: false }

const LayoutAppBar = props => {
  // ** Props
  const { settings, appBarProps, appBarContent: userAppBarContent } = props

  // ** Hooks
  const theme = useTheme()
  const isMobile = useMediaQuery('(max-width:990px)')
  const scrollTrigger = useScrollTrigger({ threshold: 0, disableHysteresis: true })
  const hideOnScroll = useScrollTrigger(HEADER_HIDE_SCROLL_OPTIONS)

  // ** Vars
  const { skin, appBar, appBarBlur, contentWidth } = settings

  const appBarFixedStyles = () => {
    return {
      background: '#F7F7F9'
    }
  }
  if (appBar === 'hidden') {
    return null
  }
  let userAppBarStyle = {}
  if (appBarProps && appBarProps.sx) {
    userAppBarStyle = appBarProps.sx
  }
  const userAppBarProps = Object.assign({}, appBarProps)
  delete userAppBarProps.sx

  // 移动端用 fixed + transform 隐藏，避免 sticky 滚动合成导致文字抖动
  const mobileHideSx = isMobile
    ? {
        top: 0,
        left: 0,
        right: 0,
        transform: hideOnScroll ? 'translateY(-110%)' : 'translateY(0)',
        pointerEvents: hideOnScroll ? 'none' : 'auto'
      }
    : {}

  return (
    <>
      <AppBar
        elevation={0}
        color='default'
        className='layout-navbar'
        sx={{
          ...userAppBarStyle,
          ...mobileHideSx
        }}
        position={isMobile ? 'fixed' : appBar === 'fixed' ? 'sticky' : 'static'}
        {...userAppBarProps}
      >
        <Toolbar
          className='navbar-content-container'
          sx={{
            ...(appBar === 'fixed' && scrollTrigger && { ...appBarFixedStyles() }),
            ...(contentWidth === 'boxed' && {
              '@media (min-width:1440px)': { maxWidth: `calc(1440px - ${theme.spacing(6)} * 2)` }
            })
          }}
        >
          {(userAppBarContent && userAppBarContent(props)) || null}
        </Toolbar>
      </AppBar>
      {/* fixed 后占位，避免内容顶到 header 下 */}
      {isMobile ? <Toolbar sx={{ minHeight: '60px !important', flexShrink: 0, visibility: 'hidden' }} /> : null}
    </>
  )
}

export default LayoutAppBar
